import { Component } from '@angular/core';
import { MedrecordIcon } from '../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-circle-arrow-left',
  templateUrl: './circle-arrow-left.component.svg',
})
export class CircleArrowLeftComponent extends MedrecordIcon {
  viewHeight = 16;
  viewWidth = 16;
}
